import React from 'react'
import { useTranslation } from 'react-i18next'

import Button from '@mui/material/Button'

const MobileShowMapButton = ({ isDesktop, toggleDrawer }) => {
  const { t } = useTranslation()

  if (isDesktop) {
    return null
  }
  return (
    <>
      <Button
        aria-label="Show Map Button"
        color="secondary"
        variant="outlined"
        onClick={() => toggleDrawer(false)}
        sx={{ border: 1, borderRadius: 5 }}
      >
        {t('Show Map')}
      </Button>
    </>
  )
}

export default MobileShowMapButton
